export default function ErrorFallback({ error }: { error: Error }) {
  return (
    <pre role="alert" aria-live="assertive">
      {error.stack || error.message || 'An unexpected error occurred.'}
    </pre>
  );
}
